import { render } from "./PromoCard.vue?vue&type=template&id=1507a903&scoped=true"
import script from "./PromoCard.vue?vue&type=script&lang=js"
export * from "./PromoCard.vue?vue&type=script&lang=js"

import "./PromoCard.vue?vue&type=style&index=0&id=1507a903&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1507a903"]])

export default __exports__